/* Warmellia theme JS: AJAX cart drawer, variant tiers, interactions. */
(function () {
  "use strict";
  var CFG = window.WARMELLIA || { moneyFormat: "£{{amount}}", freeShippingThreshold: 5000 };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return CFG.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, "");
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = $("[data-toast]"); if (!t) return;
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><path d="M20 6L9 17l-5-5"/></svg><span>' + msg + "</span>";
    t.classList.add("show"); clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- drawer ---------- */
  function openCart() { var d = $("[data-drawer]"); if (d) d.classList.add("show"); var o = $("[data-overlay]"); if (o) o.classList.add("show"); document.body.style.overflow = "hidden"; }
  function closeCart() { var d = $("[data-drawer]"); if (d) d.classList.remove("show"); var o = $("[data-overlay]"); if (o) o.classList.remove("show"); document.body.style.overflow = ""; }
  function openMnav() { var m = $("[data-mnav]"); if (m) m.classList.add("show"); var o = $("[data-overlay]"); if (o) o.classList.add("show"); document.body.style.overflow = "hidden"; }
  function closeMnav() { var m = $("[data-mnav]"); if (m) m.classList.remove("show"); var d = $("[data-drawer]"); if (!d || !d.classList.contains("show")) { var o = $("[data-overlay]"); if (o) o.classList.remove("show"); document.body.style.overflow = ""; } }

  function updateCount(n) {
    $$("[data-cart-count]").forEach(function (e) { e.textContent = n; e.classList.toggle("show", n > 0); });
  }

  function renderCart(cart) {
    var box = $("[data-cart-items]"), foot = $("[data-cart-foot]"), ship = $("[data-ship]");
    if (!box) return;
    updateCount(cart.item_count);
    if (!cart.item_count) {
      box.innerHTML = '<div class="drawer__empty"><div><b style="font-family:var(--serif);font-size:1.2rem;color:var(--plum-deep)">Your bag is empty</b><p style="margin-top:6px">Comfort is one click away.</p></div><button class="btn btn--rose" data-close-cart>Continue shopping</button></div>';
      foot.innerHTML = ""; ship.innerHTML = ""; return;
    }
    box.innerHTML = cart.items.map(function (item, i) {
      return '<div class="citem">' +
        '<a class="citem__img" href="' + item.url + '">' + (item.image ? '<img src="' + item.image + '" alt="">' : "") + "</a>" +
        '<div><div class="citem__name">' + item.product_title + '</div><div class="citem__meta">' + item.variant_title + (item.quantity > 1 ? " · " + money(item.final_price) + " each" : "") + "</div>" +
        '<div class="qty"><button data-line-dec="' + (i + 1) + '" data-q="' + item.quantity + '" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button data-line-inc="' + (i + 1) + '" data-q="' + item.quantity + '" aria-label="Increase">+</button></div></div>' +
        '<div class="citem__right"><div class="citem__price">' + money(item.final_line_price) + '</div><button class="citem__rm" data-line-rm="' + (i + 1) + '">Remove</button></div></div>';
    }).join("");
    ship.innerHTML = cart.total_price >= CFG.freeShippingThreshold
      ? "<b>Your order ships free</b> · tracked UK delivery, plain discreet packaging"
      : "<b>Free UK shipping over " + money(CFG.freeShippingThreshold) + "</b> · plain, discreet packaging on every order";
    foot.innerHTML =
      '<div class="drawer__sub"><span>Subtotal</span><b>' + money(cart.total_price) + "</b></div>" +
      '<div class="drawer__tax">Taxes included. Shipping is shown at checkout.</div>' +
      '<a href="/checkout" class="btn btn--block btn--lg">Secure checkout · ' + money(cart.total_price) + "</a>" +
      '<button class="btn btn--ghost btn--block" data-close-cart style="margin-top:10px">Continue shopping</button>';
  }

  function fetchCart() { return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); }
  function changeLine(line, qty) {
    return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); });
  }
  function addVariant(id) {
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); });
  }

  /* ---------- product buy box ---------- */
  var VARIANTS = [];
  function selectedVariantId() { var inp = $("[data-variant-input]"); return inp ? parseInt(inp.value, 10) : null; }
  function variantById(id) { for (var i = 0; i < VARIANTS.length; i++) if (VARIANTS[i].id === id) return VARIANTS[i]; return null; }

  function updateBuyUI(variantId) {
    var v = variantById(variantId); if (!v) return;
    var idx = VARIANTS.indexOf(v); var qty = idx + 1;
    var inp = $("[data-variant-input]"); if (inp) inp.value = v.id;
    $$("[data-tier]").forEach(function (b) { b.classList.toggle("active", parseInt(b.getAttribute("data-variant-id"), 10) === v.id); });
    var each = $("[data-each]"); if (each) each.textContent = qty > 1 ? money(v.price / qty) + " each" : money(v.price);
    var save = $("[data-save]");
    if (save) {
      var base = VARIANTS[0] ? VARIANTS[0].price : v.price;
      var s = base * qty - v.price;
      save.textContent = s > 0 ? "You save " + money(s) + " vs " + qty + " Singles" : "";
    }
    var btn = $("[data-btn-total]"); if (btn) btn.textContent = money(v.price);
    var sn = $("[data-ship-note]");
    if (sn) { var th = parseInt(sn.getAttribute("data-threshold"), 10) || CFG.freeShippingThreshold; sn.innerHTML = v.price >= th ? "✓ Free UK shipping included" : "The Pair unlocks free UK shipping"; }
    var st = $("[data-sticky-tier]"); if (st) st.textContent = v.title + " · " + (qty > 1 ? money(v.price / qty) + " each" : money(v.price));
    var stt = $("[data-sticky-total]"); if (stt) stt.textContent = money(v.price);
  }

  function initProduct() {
    var root = $("[data-product-root]"); if (!root) return;
    var jsonEl = $("[data-variants-json]");
    if (jsonEl) { try { VARIANTS = JSON.parse(jsonEl.textContent); } catch (e) { VARIANTS = []; } }
    var vid = selectedVariantId(); if (vid) updateBuyUI(vid);

    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-tier]");
      if (t) { updateBuyUI(parseInt(t.getAttribute("data-variant-id"), 10)); return; }
      var th = e.target.closest("[data-thumb]");
      if (th) {
        var m = $("[data-main]"); if (m) m.src = th.getAttribute("data-full");
        $$("[data-thumb]").forEach(function (b) { b.classList.remove("active"); }); th.classList.add("active");
      }
    });

    var form = $("[data-product-form]") || $('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var id = selectedVariantId(); if (!id) return;
        addVariant(id).then(function () { return fetchCart(); }).then(function () { toast("Added to your bag"); openCart(); })
          .catch(function () { toast("Sorry, that could not be added"); });
      });
    }
    var stickyAdd = $("[data-sticky-add]");
    if (stickyAdd) stickyAdd.addEventListener("click", function () {
      var id = selectedVariantId(); if (!id) return;
      addVariant(id).then(function () { return fetchCart(); }).then(function () { toast("Added to your bag"); openCart(); });
    });

    var sticky = $("[data-sticky]");
    if (sticky && "IntersectionObserver" in window) {
      new IntersectionObserver(function (ents) {
        sticky.classList.toggle("show", !ents[0].isIntersecting && ents[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(root);
    }
  }

  /* ---------- global interactions ---------- */
  function initInteractions() {
    document.addEventListener("click", function (e) {
      var t;
      if (e.target.closest("[data-open-cart]")) { fetchCart().then(openCart); }
      else if (e.target.closest("[data-close-cart]")) closeCart();
      else if (e.target.closest("[data-overlay]")) { closeCart(); closeMnav(); }
      else if (e.target.closest("[data-open-mnav]")) openMnav();
      else if (e.target.closest("[data-close-mnav]")) closeMnav();
      else if ((t = e.target.closest("[data-line-rm]"))) changeLine(parseInt(t.getAttribute("data-line-rm"), 10), 0);
      else if ((t = e.target.closest("[data-line-inc]"))) changeLine(parseInt(t.getAttribute("data-line-inc"), 10), parseInt(t.getAttribute("data-q"), 10) + 1);
      else if ((t = e.target.closest("[data-line-dec]"))) changeLine(parseInt(t.getAttribute("data-line-dec"), 10), parseInt(t.getAttribute("data-q"), 10) - 1);
      var q = e.target.closest(".faq__q");
      if (q) { var item = q.parentElement, a = item.querySelector(".faq__a"); var open = item.classList.toggle("open"); a.style.maxHeight = open ? a.scrollHeight + "px" : 0; }
    });
    var header = $("[data-header-el]");
    window.addEventListener("scroll", function () { if (header) header.classList.toggle("scrolled", window.scrollY > 20); }, { passive: true });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); closeMnav(); } });
  }

  /* ---------- reveal ---------- */
  function observeReveal() {
    if (!("IntersectionObserver" in window)) { $$(".reveal").forEach(function (n) { n.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }); }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    $$(".reveal:not(.in)").forEach(function (n) { io.observe(n); });
  }

  function boot() {
    initInteractions();
    initProduct();
    observeReveal();
    updateCount(CFG.cartCount || 0);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
